import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import { onlyUnique } from '../../../../Collections';
import ParticipantStore from '../../../../ParticipantStore';
import { licenseStatus } from '../../../../ParticipantsStore/Types';
import { T } from '../../../../Translations';

interface Props {
  store: ParticipantStore;
}

function LicenseStatus({ store }: Props) {
  return fromArrayMaybe(store.resource.payload.licenses)
    .map((licenses) =>
      licenses.map(licenseStatus).toArray().filter(onlyUnique).length === 1 ? (
        <T kind={licenseStatus(licenses.first)} />
      ) : (
        <T kind="Mixed" />
      ),
    )
    .getOrElse(() => <T kind="Not Licensed" />);
}

export default observer(LicenseStatus);
